<template>
  <textarea
    @input="handleChange"
    v-model.trim="text"
    :maxlength="maxlength"
    @focus="$emit('focus')"
    @keyup="$emit('onKeyup', $event)"
    @keyup.enter="$emit('keyupEnter', $event)"
    @keydown.enter="$emit('keydownEnter', $event)"
  ></textarea>
</template>

<script>
import autosize from 'autosize'
export default {
  props: {
    value: {
      default: null
    },
    maxlength: {
      default: null
    }
  },
  data: function() {
    return {
      text: this.value
    }
  },
  mounted() {
    this.$nextTick(() => {
      autosize(this.$el)
    })
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e.target.value)
    },
  },
  watch: {
    value: function(newVal, oldVal) {
      var vm = this
      if (newVal != oldVal) {
        vm.text = vm.value
        vm.$nextTick(function() {
          autosize.update(vm.$el)
        })
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/AutoresizeTextarea.vue